module.exports = __webpack_public_path__ + "media/images/favicon/right-arrow-a3e3bd321351d7e6b273c8036ec173dc.png";